import React, { useContext } from 'react';
import { ProgressBar, TooltipTrigger } from '@spark';
import { GlobalContext } from '@/app/providers/globalState';
import { getEffectiveProgress } from '@/features/trainings/utils/llmJudgeProgress';

const TrainingProgress = ({ distillationEventId, initialProgress, initialStatus, usecaseId, version }) => {
    const { trainStatuses, evaluationProgress } = useContext(GlobalContext);
    const trainingStatus = trainStatuses[distillationEventId] || {
        "progress": initialProgress,
        "status": initialStatus,
        "error_details": null
    };
    const effectiveProgress = getEffectiveProgress(
        trainingStatus.status,
        trainingStatus.progress,
        evaluationProgress,
        usecaseId || trainingStatus.usecase_id,
        version,
    );

    const getProgressType = () => {
        if (trainingStatus.status === 'failed') {
            return 'error';
        }
        return 'default';
    };

    const progressBar = (
        <ProgressBar
            value={effectiveProgress}
            type={getProgressType()}
            showPercentage={true}
        />
    );

    if (trainingStatus.status === 'failed' && trainingStatus.error_details) {
        return (
            <TooltipTrigger
                text={`Training Failed: ${trainingStatus.error_details}`}
                placement="top"
            >
                <div style={{ cursor: 'pointer' }}>
                    {progressBar}
                </div>
            </TooltipTrigger>
        );
    }

    return progressBar;
};

export default TrainingProgress;
